import {
  CAB_ONBOARDING_FLOW_ID,
  ONBOARDING_RELEASE_VERSION,
  type OnboardingReleaseVersion,
} from '@galapagos/shared';

// Single source of truth for the onboarding flow's identity. Lives in the
// shared flow package (not in either app) so the mobile onboarding-session
// services layer and the web flow host read one canonical value — a local copy
// of the literal on either side would let a flow revision move the value on
// one platform only.

export const ONBOARDING_FLOW_ID = 'onboarding-flow';
// Keys on-device session state and the bundled definition's `flow_version`.
// It is not what the server records: that is `ONBOARDING_RELEASE_VERSION`
// in shared. Changing this value re-keys saved answers on the device.
export const ONBOARDING_FLOW_VERSION = 'onboarding-flow@2';

export { ONBOARDING_RELEASE_VERSION, type OnboardingReleaseVersion } from '@galapagos/shared';

/**
 * The release version for a session written through the generic save path,
 * which only knows the flow id. Only the normal and CAB flows write through that
 * path; any other flow gets no version rather than a guessed one.
 */
export function onboardingReleaseVersionForFlow(
  flowId: string,
): OnboardingReleaseVersion | undefined {
  if (flowId === ONBOARDING_FLOW_ID) return ONBOARDING_RELEASE_VERSION.normal;
  if (flowId === CAB_ONBOARDING_FLOW_ID) return ONBOARDING_RELEASE_VERSION.cab;
  return undefined;
}
